import { SerializedData, AnalyticsStore } from 'bernie-core';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { BexApiStore, RequestOptions } from 'bernie-graphql';

import { FlightsFlexibleSearch } from '__generated__/api/';
import analyticsWrapper from 'utility/analytics-wrapper';
import { clientInfoHeader } from 'utility/header-utils';

export class FlexibleSearchStore extends BexApiStore {
  public hydrate(data: SerializedData): void {
    super.hydrate(data);

    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  public fetchResults(
    searchVariables: FlightsFlexibleSearch.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsFlexibleSearch.FlightsSearch> {
    this.logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), this.bexApiSource.clientConfigs.bexApiUrl);

    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = clientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsFlexibleSearch(searchVariables, options)
      .then(response => {
        const { flightsSearch } = response.data;

        analyticsWrapper.setFlexibleSearchAnalytics(response);
        analyticsWrapper.publishSearchAnalyticsPayload(analytics);

        return {
          ...flightsSearch
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'ENVERROR'), error);

        return null;
      });
  }
}
